import React from 'react';
import { MessageCircle, Instagram } from 'lucide-react';
import { openWhatsApp } from '../../lib/whatsapp';

export const CTASection = () => {
  const handleWhatsAppClick = () => {
    openWhatsApp('Namaste Nitika Ji, I would like to book a consultation.');
  };

  return (
    <section className="py-20 sm:py-28 bg-gradient-to-b from-[#1A0B0C] to-[#0A0000]">
      <div className="container mx-auto px-4 max-w-2xl text-center">
        <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl font-medium text-white mb-6">
          Ready to begin your journey?
        </h2>

        <p className="text-[#E8DCC4] text-base sm:text-lg mb-10 max-w-xl mx-auto">
          Personal guidance through Astrology, Tarot, Numerology and more. Message Nitika directly on WhatsApp.
        </p>

        <button
          onClick={handleWhatsAppClick}
          className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-black font-bold text-lg sm:text-xl rounded-full shadow-xl hover:shadow-2xl transition-shadow duration-300"
          data-testid="cta-whatsapp-button"
        >
          <MessageCircle className="w-6 h-6" />
          Book Consultation on WhatsApp
        </button>

        <a
          href="https://www.instagram.com/nitikabhola_astro"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-[#A89B8C] hover:text-[#D4AF37] transition-colors duration-200 mt-8 text-sm"
        >
          <Instagram className="w-4 h-4" />
          @nitikabhola_astro
        </a>

        <p className="text-center text-[#A89B8C] text-xs mt-4">
          🔒 Instant redirect to WhatsApp · No registration required
        </p>

        <p className="text-center text-[#A89B8C] text-xs mt-6">
          © 2026 Nitika Bhola Astrology. All rights reserved.
        </p>
      </div>
    </section>
  );
};
